export const FAVORITE_TOKENS_KEY = "favorite_tokens";
export const HISTORY_TOKENS_KEY = "history_tokens";

export const toggleFavouriteToken = (tokenId: string | undefined): string[] => {
  if (!tokenId) return [];

  const current = JSON.parse(localStorage.getItem(FAVORITE_TOKENS_KEY) || "[]");

  let updated: string[];
  if (current.includes(tokenId)) {
    updated = current.filter((id: string) => id !== tokenId);
  } else {
    updated = [tokenId, ...current].slice(0, 50);
  }

  localStorage.setItem(FAVORITE_TOKENS_KEY, JSON.stringify(updated));
  return updated;
};

export const getFavouriteTokens = (): string[] => {
  return JSON.parse(localStorage.getItem(FAVORITE_TOKENS_KEY) || "[]");
};

export const isTokenFavourite = (tokenId: string): boolean => {
  const favourites = getFavouriteTokens();
  return favourites.includes(tokenId);
};

export const getHistoryTokens = (): string[] => {
  return JSON.parse(localStorage.getItem(HISTORY_TOKENS_KEY) || "[]");
};

export const addToHistoryTokens = (tokenId: string): string[] => {
  const current: string[] = JSON.parse(
    localStorage.getItem(HISTORY_TOKENS_KEY) || "[]",
  );

  const updated = current.filter((id) => id !== tokenId);

  updated.unshift(tokenId);
  const limited = updated.slice(0, 100);

  localStorage.setItem(HISTORY_TOKENS_KEY, JSON.stringify(limited));
  return updated;
};
